export default __webpack_public_path__ + "static/media/refresh.a244e622.png";